module.exports = __webpack_public_path__ + "f35642d3222179a37ae4fdc517f655b9.svg";